// 261005 E1-P2 — chặng ⑤ Kịch bản. 261023 E3-P3kc (User 26/10 «thấy ngay nội dung tập · cột bước bên trái · thông tin hiện đủ»): vào ⑤ là MỞ SẴN một tập (tập đầu tiên đang có lỗi, không có thì tập 1; `?ep=` thắng — chốt MỘT lần, `defaultOpenEpisodeOf`);
// danh sách tập (ô tick · lọc · chip · nút viết dải liền) về CỘT TRÁI (khe `side`); «Đẩy N tập» (truyện không chạy chuỗi) + «Đọc cả mùa» ở đáy cột (khe `sideFoot`); lý do cấp CHẶNG ở đầu vùng nội dung; «⋯» gộp mục danh sách + mục tập (nguồn `list` và `episode`).
// Bảng tập (`EpisodeTable`), hộp «Chọn tập…» (Drawer) và hộp «Xem» máy-đã-sửa (thẻ nay hiện thẳng ở trang tập) đã gỡ. Mọi lời gọi API ghi giữ nguyên P1 (`scriptJob.writeScripts`, SeasonReaderCard, HandoffModal; sửa tập đi qua khung Trợ lý AI). Hàm quyết định ở `scriptStageView.ts` / `episodeRowView.ts` / `scriptMenuView.ts`.
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Alert, Card, Col, Drawer, Empty, Modal, Row, Statistic, Tooltip, Typography } from 'antd';
import Button from '../WbButton';
import { useSearchParams } from 'react-router-dom';
import type { OutlineEpisode } from '../../../../types/adaptation';
import { seasonIssueDisabledReason } from '../assistant/optionsAction';
import SeasonReaderCard from '../../SeasonReaderCard';
import { evidenceCellLines, humanizeCodes, summarizeScriptPlans } from '../../adaptationUtils';
import { seasonReaderCardView } from '../../seasonReaderView';
import EpisodeList from '../EpisodeList';
import WbSlot, { Bang } from '../WbSlot';
import { chainRunningOf, defaultEpisodeGate, defaultOpenEpisodeOf, episodeRowsOf, matchesListFilter, scriptTableDuringChain, stageLevelNeeds } from '../episodeRowView';
import { listMenuOf } from '../scriptMenuView';
import { AUTO_REPAIR_ONE_LABEL, AUTO_REPAIR_STOP_LABEL, autoRepairOneOf, autoRepairStripOf } from '../autoRepairView';
import { useAutoRepair } from '../useAutoRepair';
import EpisodeReader from '../EpisodeReader';
import type { AssistantRequest } from '../assistant/assistantIntent';
import HandoffModal from '../HandoffModal';
import { useHandoffClick } from '../useHandoffClick';
import { useVisualExtras } from '../useVisualExtras';
import { VisualExtrasBulkBar } from '../VisualExtrasPanel';
import ScriptFooter from '../ScriptFooter';
import StageFrame from '../StageFrame';
import ConsequenceModal from '../ConsequenceModal';
import { rewriteCopy } from '../consequenceCopy';
import { REWRITE_STALE } from '../consequenceView';
import { adaptationApi } from '../../../../services/api/adaptation';
import { useCtaHolds, useStageIntent, useWorkbenchCtx } from '../WorkbenchContext';
import HandoffBatchResults from '../HandoffBatchResults';
import { batchItemsOf, isPushable, pushBarOf, pushStripOf } from '../handoffBatchView';
import { useHandoffBatchActions, useHandoffPreview } from '../useHandoffBatch';
import { backToReviewParams, DROPPED_ANCHOR_ID, reviewOriginOf, sceneAnchorId } from '../reviewBookView';
import { scrollWhenReady } from '../useScrollWhenReady';
import {
  EpisodeFilter, episodeReviewReasons, hiddenSelectedCount, parseEpParam, rangeWritePlan, withLiveErrors,
  readerFooter, readerIssuesFor, readerNotesFor, selectionLabel, selectionOrder, toggleSelect, writeOneBlocker,
} from '../scriptStageView';
import { dangerCopy, DangerCopyView, reasonTarget } from '../workbenchView';
import { FILTER_SEEN_KEY, readId, shouldDefaultNewFilter, writeId } from '../appendRunView';
import { friendlyReasonText } from '../jobErrorText';
import { pickJobId } from '../jobTracking';
import { episodePlanCopy } from '../episodePlanView';
import { originalNameSummaryNotice } from '../../localizedNameNotice';

const { Text } = Typography;

const ScriptStage: React.FC = () => {
  const {
    storyId, dataVersion, data, workbench, refreshAll, busy, scriptJob, stageState, goTo, slots, intent, setScriptEpisode, requestAssistant, clearAssistantIntent, scriptEditing, notifyScriptSaved, seasonReader, setTopMenuSource, chainActive,
  } = useWorkbenchCtx();
  const [searchParams, setSearchParams] = useSearchParams();
  const pushCta = useCtaHolds().holds('pushbar');   // 3h3: thanh đáy chỉ đỏ khi dải KHÔNG giữ việc đẩy
  // 3h3 (K12): thanh dính đáy ⑤ đọc CÙNG `pushStripOf` với dải — một luật cho cả hai chỗ.
  const barEps = workbench?.episodes;
  const barItems = useMemo(() => batchItemsOf(barEps ?? [], (barEps ?? []).filter(isPushable).map((e) => e.ep)), [barEps]);
  const barBatch = workbench?.handoffBatch ?? null;
  const barPreview = useHandoffPreview(storyId, barItems, dataVersion, barItems.length > 0 && barBatch?.status !== 'RUNNING');
  const barBatchActions = useHandoffBatchActions(storyId, barBatch, refreshAll);
  const autoRepairApi = useAutoRepair();   // 3j2b-2: «Để máy sửa N tập» / «Dừng» (đáy cột khi không có dải) và «Để máy sửa tập này» (trang tập)
  const handoff = useHandoffClick();   // 261015 P5a (D7): bấm ⇒ GET kế hoạch ⇒ toast / đẩy thẳng / hộp (chỉ khi có tên gốc rò)
  const [readerOpen, setReaderOpen] = useState(false);
  const [filter, setFilter] = useState<EpisodeFilter>('all');
  const [selected, setSelected] = useState<number[]>([]);
  const [anchor, setAnchor] = useState<number | null>(null);
  // 261005 E4-P4b STOP 2: đợt vừa xong ⇒ bộ lọc "Tập mới" (tập > M) ở danh sách tập (cột trái); lần đầu thấy (theo id đợt) thì lọc mặc định.
  const appendRun = workbench?.appendRun ?? null;
  const filterCtx = useMemo(() => (appendRun?.status === 'DONE' ? { lockedThrough: appendRun.lockedThrough } : undefined), [appendRun]);
  useEffect(() => {
    if (!appendRun || !shouldDefaultNewFilter(appendRun, readId(FILTER_SEEN_KEY(storyId)))) return;
    writeId(FILTER_SEEN_KEY(storyId), appendRun.id);
    setFilter('new');
  }, [appendRun, storyId]);

  // 261012 E1-P4 — người phụ không tên: MỘT instance cho cả chặng (panel của tập đang mở + thanh hàng loạt). Mọi POST đi qua hộp xác nhận.
  const confirmExtras = useCallback((c: DangerCopyView, run: () => void | Promise<void>) => {
    Modal.confirm({ title: c.title, content: c.content, okText: c.okText, cancelText: 'Thôi', okButtonProps: { danger: c.danger }, onOk: run });
  }, []);
  const visualExtras = useVisualExtras({ confirmCopy: confirmExtras });

  const outline = data.record?.outline ?? null;
  const originalNameNotice = originalNameSummaryNotice(outline?.characters);
  const scripts = data.scripts;
  const scriptByEp = useMemo(() => new Map(scripts.map((x) => [x.episode, x])), [scripts]);
  const locked = stageState('script') === 'locked';
  const disabled = busy || scriptJob.starting || !!scriptJob.scriptJob || locked;
  const episodePlan = workbench?.episodePlan ?? data.record?.episodePlan;
  const planBlocked = episodePlan?.state === 'PENDING' || episodePlan?.state === 'STALE';
  const planCopy = episodePlanCopy(episodePlan);
  const planBlockedText = planBlocked ? planCopy.text : '';
  const planExitText = planCopy.action === 'resplit' ? 'Mở Chia tập để chia lại' : planCopy.action === 'reapprove' ? 'Mở Chia tập để chốt lại' : 'Mở Chia tập để chốt';
  const splitMode = outline?.splitMode ?? null;
  // 261015 P2b-2 (Q1): số lỗi chặn theo danh sách GET (có bản tính lại), không theo số BE đếm trên ảnh chụp lúc viết.
  const wbEpisodes = useMemo(() => (workbench?.episodes ?? []).map((e) => withLiveErrors(e, scriptByEp.get(e.ep))), [workbench, scriptByEp]);
  const wbByEp = useMemo(() => new Map(wbEpisodes.map((e) => [e.ep, e])), [wbEpisodes]);
  const versionOf = (ep: number) => wbByEp.get(ep)?.versionCount ?? 0;

  // Hàng danh sách = tập trong khung xương + (nếu có) kịch bản ngoài khung xương, để "Cần bạn xem" tới được ORPHAN_SCRIPT.
  const rows: OutlineEpisode[] = useMemo(() => {
    const base = outline?.episodes ?? [];
    const inOutline = new Set(base.map((e) => e.ep));
    const orphans = scripts.filter((s) => !inOutline.has(s.episode)).map((s) => (
      { ep: s.episode, synopsis: '(tập ngoài khung xương)', hook: '', suspense: '', characterIds: [], locationIds: [] } as OutlineEpisode
    ));
    return [...base, ...orphans].sort((a, b) => a.ep - b.ep);
  }, [outline, scripts]);
  const order = useMemo(() => selectionOrder(outline), [outline]);

  // AI đọc cả mùa: MỘT hook ở vỏ (dùng chung với Sổ duyệt; 261023 E3-P3a) cho khung đọc + đáy + Drawer. Không có kịch bản ⇒ vỏ không gọi.
  const readerView = useMemo(() => seasonReaderCardView(seasonReader.resp), [seasonReader.resp]);
  const readerIssues = useMemo(() => readerIssuesFor(readerView), [readerView]);

  // 3k-c (C2): dòng tập (chip) tính SỚM — tập mặc định cần chip. `chain` = chuỗi «Truyện mới» ĐANG CHẠY (chỉ để chọn nhãn «Chờ»); «máy đã thử sửa» lấy từ bằng chứng của TỪNG tập.
  const chain = chainRunningOf(workbench);
  const rowsView = useMemo(() => episodeRowsOf({ rows, episodes: wbEpisodes, scripts, chain, chainProgress: workbench?.chainProgress, autoRepair: workbench?.autoRepair }), [rows, wbEpisodes, scripts, chain, workbench?.chainProgress, workbench?.autoRepair]);
  const rowViewOf = (ep: number) => rowsView.find((r) => r.ep === ep);
  const rowViews = useMemo(() => new Map(rowsView.map((r) => [r.ep, r])), [rowsView]);

  // Tập đang mở = `?ep=` hợp lệ. Không có ⇒ CHỐT MỘT LẦN tập mặc định (`defaultOpenEpisodeOf`) rồi GHI vào URL (replace — không thêm bước lịch sử). Sau đó KHÔNG BAO GIỜ tự nhảy tập khi dữ liệu đổi:
  // `EpisodeReader` có `key={selectedEp}` + `editBase` cục bộ ⇒ nhảy là mất bản sửa tay đang dở. Chỉ chạy khi workbench + dòng tập đã tải (trước đó mọi dòng đọc «Chờ» ⇒ sẽ ghi nhầm `ep=1`).
  const urlEp = parseEpParam(searchParams.get('ep'));
  const inRows = (n: number | null): n is number => n !== null && rows.some((r) => r.ep === n);
  const selectedEp: number | null = inRows(urlEp) ? urlEp : null;
  const defaultDone = useRef(false);
  const [settled, setSettled] = useState(false);   // đã qua cổng chốt tập mặc định (để khỏi nháy câu «Chọn một tập…» trước khi `ep` được ghi)
  const gate = defaultEpisodeGate({
    workbenchReady: !!workbench, rowCount: rowsView.length, chainRunning: chain, anyWritten: scriptTableDuringChain(workbench?.episodes), urlEpValid: inRows(urlEp),
    intentOpensEp: intent?.stage === 'script' && intent.episode !== undefined,   // «Xem tập n» từ dải / Sổ: ý định mở tập sẽ tự ghi URL — không giành
  });
  useEffect(() => {
    if (defaultDone.current || gate === 'wait') return;
    defaultDone.current = true;
    setSettled(true);
    if (gate === 'skip') return;
    const ep = defaultOpenEpisodeOf(rowsView, urlEp);
    if (ep === null) { defaultDone.current = false; setSettled(false); return; }
    setSearchParams((prev) => { const n = new URLSearchParams(prev); n.set('ep', String(ep)); return n; }, { replace: true });
    // chỉ cần chạy khi cổng đổi; đã chốt thì không tính lại
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gate]);

  // Báo lên vỏ tập đang mở để khung Trợ lý biết nói về tập nào (R3/Y3): CHỈ khi workbench đã tải và tập CÓ kịch bản (chưa mở tập nào ⇒ null).
  // Chưa có kịch bản ⇒ báo riêng `noScript` để khung nêu lý do. Rời chặng (unmount) ⇒ null.
  const hasScript = selectedEp !== null && scriptByEp.has(selectedEp);
  const workbenchReady = !!workbench;
  useEffect(() => {
    if (!workbenchReady || selectedEp === null) setScriptEpisode(null, null);
    else if (hasScript) setScriptEpisode(selectedEp, null);
    else setScriptEpisode(null, selectedEp);
  }, [selectedEp, hasScript, workbenchReady, setScriptEpisode]);
  useEffect(() => () => setScriptEpisode(null, null), [setScriptEpisode]);

  // 261005 E4-P1 — sửa tay chưa lưu: đổi tập ⇒ hỏi lại (Back trình duyệt / đổi chặng CHƯA chặn — nợ TD; `beforeunload` ở ScriptEditor).
  const editDirty = useRef(false);
  const onEditDirty = useCallback((d: boolean) => { editDirty.current = d; }, []);
  const openEpisode = (ep: number) => {
    if (editDirty.current && ep !== selectedEp) {
      Modal.confirm({
        title: 'Bỏ thay đổi chưa lưu?', content: `Bạn đang sửa tay tập ${selectedEp} và chưa lưu. Sang tập ${ep} sẽ mất phần đang sửa.`,
        okText: 'Bỏ và sang tập khác', cancelText: 'Ở lại sửa', okButtonProps: { danger: true },
        onOk: () => { editDirty.current = false; goToEpisode(ep); },
      });
      return;
    }
    goToEpisode(ep);
  };
  const goToEpisode = (ep: number) => {
    // 261023 E3-P3a: `scene` / `open` chỉ có nghĩa cho tập vừa mở từ Sổ — chọn tập khác thì bỏ.
    setSearchParams((prev) => { const n = new URLSearchParams(prev); n.set('ep', String(ep)); n.delete('scene'); n.delete('open'); return n; }, { replace: true });
  };

  // 261005 E2-P2b — nút "Trợ lý AI"/"Nhờ AI sửa"/"Hỏi trợ lý"/"Phiên bản": mở tập đó rồi nhờ khung (không tự gửi).
  const onAskAssistant = (req: AssistantRequest) => { if (req.episode !== undefined) openEpisode(req.episode); requestAssistant(req); };
  // Người dùng TỰ chọn tập ở danh sách ⇒ hủy ý định đang chờ (A3), khỏi bật lại ở lần mở sau.
  const openByHand = (ep: number) => { clearAssistantIntent(); openEpisode(ep); };

  // 261023 E3-P3a — đến từ Sổ duyệt: cuộn tới đúng cảnh (`scene`) hoặc khối «chưa lên phim» (`open=dropped`) khi kịch bản đã vẽ; thanh «Về Sổ duyệt» đẩy lịch sử.
  const origin = reviewOriginOf(searchParams);
  useEffect(() => {
    if (!hasScript || selectedEp === null) return undefined;
    if (origin.openDropped) return scrollWhenReady(DROPPED_ANCHOR_ID, undefined, { block: 'start' });
    if (origin.scene) return scrollWhenReady(sceneAnchorId(origin.scene), undefined, { block: 'start' });
    // Từ Sổ duyệt nhưng không nhắm cảnh/khối nào: vùng giữa (`.wb-scroll`) dùng chung với Sổ ⇒ còn nguyên vị trí cuộn của bảng, thanh «Về Sổ duyệt» trôi khỏi màn. Đưa về đầu.
    if (origin.fromReview) document.querySelector('.wb .wb-scroll')?.scrollTo({ top: 0 });
    return undefined;
  }, [origin.scene, origin.openDropped, origin.fromReview, selectedEp, hasScript]);
  const backToReview = () => {
    const go = () => { editDirty.current = false; setSearchParams((prev) => backToReviewParams(prev)); };
    if (editDirty.current) {
      Modal.confirm({
        title: 'Bỏ thay đổi chưa lưu?', content: `Bạn đang sửa tay tập ${selectedEp} và chưa lưu. Về Sổ duyệt sẽ mất phần đang sửa.`,
        okText: 'Bỏ và về Sổ duyệt', cancelText: 'Ở lại sửa', okButtonProps: { danger: true }, onOk: go,
      });
      return;
    }
    go();
  };

  /** Tập chưa có kịch bản DRAFT (backend viết lại mọi tập không DRAFT — gồm cả tập hỏng). */
  const missing = (outline?.episodes ?? []).filter((e) => scriptByEp.get(e.ep)?.status !== 'DRAFT').length;
  const scriptSummary = summarizeScriptPlans(scripts);
  const stageWb = workbench?.stages.find((s) => s.key === 'script');
  // 261005 E5: mục cấp chặng KHÔNG nói về tập đang mở nhập chung một danh sách với lý do của tập (dưới tiêu đề); mục nói về đúng tập này thì bỏ (trùng).
  const stageNeeds = [...(stageWb?.blockers ?? []).map((r) => ({ r, blocker: true })), ...(stageWb?.attention ?? []).map((r) => ({ r, blocker: false }))]
    .filter(({ r }) => r.episode === undefined || r.episode !== selectedEp)
    .map(({ r, blocker }) => ({ text: friendlyReasonText(r.message), blocker, ep: r.episode, go: () => goTo(reasonTarget('script', r, wbEpisodes.map((e) => ({ ep: e.ep, written: e.written })))) }));

  useStageIntent('script', (t) => {
    if (t.episode !== undefined && (t.intent === 'openEpisode' || t.intent === 'markEpisode')) {
      const w = wbByEp.get(t.episode);
      if (filter !== 'all' && w && !matchesListFilter(w, rowViews.get(t.episode), filter, filterCtx)) setFilter('all');
      openEpisode(t.episode);
    }
    if (t.intent === 'writeMissing') { setSelected([]); setAnchor(null); }   // 3k-c: nút viết (`btn-write-missing`) nằm ở cột trái, luôn thấy — intent chỉ bỏ chọn rồi cuộn tới nó
    if (t.intent === 'handoff') void handoff.click();
    if (t.intent === 'seasonReader' && readerView) setReaderOpen(true);
  });

  const confirmWriteMissing = () => {
    if (locked) return;
    const c = dangerCopy('writeMissing', { n: missing });
    Modal.confirm({ title: c.title, content: c.content, okText: c.okText, cancelText: 'Thôi', onOk: () => scriptJob.writeScripts() });
  };
  const [rewriteEp, setRewriteEp] = useState<number | null>(null);
  const writeOne = (ep: number) => {
    if (locked) return;
    if (!scriptByEp.get(ep) && planBlocked) { goTo({ stage: 'split' }); return; }
    const run = () => scriptJob.writeScripts({ from: ep, to: ep, force: true }, `Viết lại tập ${ep}`);
    if (scriptByEp.get(ep)) {
      setRewriteEp(ep);   // 3h4c: «hộp hậu quả» (BE) thay hộp hỏi tĩnh; preview lỗi ⇒ hộp cũ (cùng chữ `dangerCopy('rewriteEpisode')`)
    } else {
      Modal.confirm({ title: `Viết tập ${ep}?`, content: `Chạy nền, tốn AI — chỉ viết kịch bản tập ${ep}.`, okText: `Viết tập ${ep}`, cancelText: 'Thôi', onOk: run });
    }
  };
  const rewriteRange = (opts: { from: number; to: number; force: true }) => { if (!locked) scriptJob.writeScripts(opts); };

  // Viết từ danh sách (một chỗ duy nhất).
  const plan = rangeWritePlan(selected, order, scripts, splitMode);
  const visibleEps = rows.filter((r) => { const w = wbByEp.get(r.ep); return !w || matchesListFilter(w, rowViews.get(r.ep), filter, filterCtx); }).map((r) => r.ep);
  const selectionText = selectionLabel(selected, hiddenSelectedCount(selected, visibleEps));
  const onSelect = (ep: number, shift: boolean) => {
    const r = toggleSelect(selected, ep, shift, anchor, order);
    setSelected(r.selected); setAnchor(r.anchor);
  };
  const confirmWriteRange = () => {
    if (locked || plan.kind !== 'range' || plan.todo === 0) return;
    const c = dangerCopy('writeRange', { from: plan.from, to: plan.to, n: plan.todo, skipped: plan.skipped, splitMode });
    Modal.confirm({
      title: c.title, content: c.content, okText: c.okText, cancelText: 'Thôi',
      onOk: () => scriptJob.writeScripts({ from: plan.from, to: plan.to }, `Viết tập ${plan.from}–${plan.to}`),
    });
  };

  const writeButton = (() => {
    const base = { id: 'btn-write-missing', block: true, type: 'primary' as const };
    const running = scriptJob.starting || !!scriptJob.scriptJob;
    switch (plan.kind) {
      case 'range':
        return plan.todo > 0 ? (
          <Button {...base} disabled={disabled || planBlocked} loading={running} onClick={confirmWriteRange}>
            {running ? 'Đang viết kịch bản…' : `Viết tập ${plan.from}–${plan.to} (${plan.todo} chưa viết)`}
          </Button>
        ) : (
          <>
            <Button {...base} disabled>{`Tập ${plan.from}–${plan.to} đã viết hết`}</Button>
            <Text type="secondary" style={{ fontSize: 13 }}>Muốn viết lại thì dùng Viết lại ở từng tập</Text>
          </>
        );
      case 'gap':
        return (
          <>
            <Button {...base} disabled>Viết các tập đã chọn</Button>
            <Text type="secondary" style={{ fontSize: 13 }}>Chọn một dải liền (giữ Shift để chọn cả đoạn) hoặc viết từng tập</Text>
          </>
        );
      case 'blocked':
        return (
          <>
            <Button {...base} disabled>Viết các tập đã chọn</Button>
            <Text type="secondary" style={{ fontSize: 13 }}>Cần viết tập {plan.prev} trước (truyện theo đoạn nguồn viết tuần tự)</Text>
          </>
        );
      default:
        if (missing === 0 && !running) return null;   // 3k-c lượt 2: không còn tập nào để viết ⇒ ẨN nút «Viết 0 tập chưa viết»
        return (
          <Button {...base} disabled={disabled || missing === 0 || planBlocked} loading={running} onClick={confirmWriteMissing}>
            {scriptJob.scriptJob ? 'Đang viết kịch bản…' : `Viết ${missing} tập chưa viết`}
          </Button>
        );
    }
  })();

  const jobLine = scriptJob.scriptJob
    ? `⏳ Đang viết kịch bản${scriptJob.progress ? ` — ${scriptJob.progress}` : ''}`
    : (workbench?.jobs.running.some((j) => j.kind === 'write') ? '⏳ Đang viết kịch bản' : null);

  const techExtra = scripts.length > 0 ? (
    <Card size="small" title="Scene Plan & bằng chứng" extra={<Text type="secondary" style={{ fontSize: 13 }}>Số đếm từ kịch bản đang lưu</Text>}>
      <Row gutter={[12, 12]}>
        <Col span={8}><Statistic title="Có Scene Plan" value={scriptSummary.scriptsWithPlan} suffix={`/ ${scriptSummary.scriptsWithPlan + scriptSummary.legacyScripts}`} />
          <Text type="secondary" style={{ fontSize: 13 }}>{scriptSummary.legacyScripts} kịch bản cũ</Text></Col>
        <Col span={8}><Statistic title="Trực tiếp từ nguồn" value={scriptSummary.sourceDirect} /></Col>
        <Col span={8}><Statistic title="Suy ra từ nguồn" value={scriptSummary.sourceDerived} /></Col>
        <Col span={8}><Statistic title="Thêm khi chuyển thể" value={scriptSummary.adaptationAdded} /></Col>
        {/* 261015 P5a (D8): hai dòng — "Thiếu bằng chứng" (lỗi) tách khỏi "Chưa kiểm được — nguồn không có" (chưa kiểm, xám); tổng cũ = cộng hai dòng. */}
        <Col span={8}>
          {evidenceCellLines(scriptSummary).map((l) => (
            <Statistic
              key={l.key} title={l.label} value={l.value}
              valueStyle={l.tone === 'unchecked' ? { color: 'var(--wb-text-3, #8c8c8c)', fontSize: 18 } : (l.value > 0 ? { color: 'var(--wb-bad, #cf1322)' } : undefined)}
            />
          ))}
          {scriptSummary.failedScripts > 0 && <Text type="danger" style={{ fontSize: 13 }}>{scriptSummary.failedScripts} tập có lỗi</Text>}</Col>
      </Row>
    </Card>
  ) : null;

  const wbEp = selectedEp !== null ? wbByEp.get(selectedEp) : undefined;
  const script = selectedEp !== null ? scriptByEp.get(selectedEp) : undefined;

  // ─── 3k-c: «⋯» — nhóm DANH SÁCH (hiện ở MỌI trạng thái, kể cả khi đang mở một tập; mục của tập do `EpisodeReader` đặt ở nguồn `episode`) ──
  const listItems = useMemo(() => listMenuOf({ missing, locked, busy: disabled, planBlocked, scriptCount: scripts.length, readerReady: !!readerView, pushAvailable: true }), [missing, locked, disabled, planBlocked, scripts.length, readerView]);
  const handlersNow = { confirmWriteMissing, push: () => { void handoff.click(); }, reader: () => setReaderOpen(true) };
  const listHandlers = useRef(handlersNow);
  listHandlers.current = handlersNow;
  const listSig = listItems.map((i) => `${i.key}:${i.label}:${i.disabled ? 1 : 0}:${i.reason ?? ''}`).join('|');
  useEffect(() => {
    setTopMenuSource('list', listItems.map((i) => ({
      key: i.key, label: i.label, danger: i.danger, disabled: i.disabled, reason: i.reason,
      onSelect: () => {
        const h = listHandlers.current;
        if (i.key === 'writeMissing') h.confirmWriteMissing(); else if (i.key === 'pushAll') h.push(); else if (i.key === 'reader') h.reader();
      },
    })));
    return () => setTopMenuSource('list', []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listSig, setTopMenuSource]);

  // Lý do cấp CHẶNG (không thuộc tập nào) ở ĐẦU vùng nội dung, trên tiêu đề tập; lý do của một tập khác vẫn trong khối «Cần xem» của trang tập.
  const listNeeds = stageLevelNeeds(stageNeeds);
  const episodeNeeds = stageNeeds.filter((n) => n.ep !== undefined);
  const arStrip = autoRepairStripOf(workbench?.autoRepair);
  // «Đẩy riêng tập này»: CÙNG đường «Duyệt & đẩy» theo lô (một tập) — qua cổng BE như cũ; không đủ điều kiện ⇒ mục mờ kèm lý do.
  const pushOneEp = (ep: number) => { if (workbench && !barBatchActions.starting) void barBatchActions.start(workbench.episodes, [ep]); };

  return (
    <StageFrame
      stage="script" lockMode="buttons" hideNeeds gate={{ label: 'AI đọc cả mùa', gate: outline?.reviewGates?.season_reader }} techExtra={techExtra}
    >
      {planBlocked && (
        <Alert
          style={{ marginBottom: 8 }} type="warning" showIcon
          message={planBlockedText}
          description="Các tập đã có kịch bản vẫn có thể sửa hoặc viết lại; việc này chỉ chặn tạo kịch bản mới."
          action={<Button size="small" type="primary" onClick={() => goTo({ stage: 'split' })}>{planExitText}</Button>}
        />
      )}

      {/* 3k-c: danh sách tập ở CỘT TRÁI (ô tick · lọc · chip · «Viết N tập chưa viết» / viết dải liền); props + handler giữ nguyên, chip lấy từ dòng tập. */}
      <WbSlot to={slots.side}>
        <EpisodeList
          rows={rows} episodes={wbEpisodes} rowViews={rowViews} selectedEp={selectedEp} onOpen={openByHand} order={order}
          selected={selected} onSelect={onSelect} selectionText={selectionText} onClearSelection={() => { setSelected([]); setAnchor(null); }}
          filter={filter} onFilter={setFilter} filterCtx={filterCtx} locked={locked} compact={false} jobLine={jobLine}
          writeArea={<div className="wb-write-area">{writeButton}</div>} onGoSplit={() => goTo({ stage: 'split' })}
        />
      </WbSlot>
      {/* Đáy cột: «Đẩy N tập» (truyện KHÔNG chạy chuỗi — truyện chạy chuỗi có nút đỏ ở dải) rồi «Đọc cả mùa». Thấy cả khi đang mở một tập. */}
      <WbSlot to={slots.sideFoot}>
        {/* 3j2b-2 (D8): truyện KHÔNG có dải ⇒ nút đỏ «Để máy sửa N tập» ở đây, TRÊN «Đẩy N tập» (đang chạy: câu + «Dừng», không nút đỏ). Có dải ⇒ nút ở dải. */}
        {!chainActive && arStrip && (
          <div className="wb-autorepair" role="region" aria-label="Máy tự sửa" data-testid="autorepair-side">
            <span className="wb-autorepair-t">{arStrip.sentence}</span>
            {arStrip.mode === 'running'
              ? <Button size="small" loading={autoRepairApi.stopping} onClick={() => { void autoRepairApi.stop(); }}>{AUTO_REPAIR_STOP_LABEL}</Button>
              : <Button type="primary" cta={pushCta} loading={autoRepairApi.starting} disabled={disabled || autoRepairApi.starting} onClick={() => { void autoRepairApi.start(); }}>{arStrip.label}</Button>}
          </div>
        )}
        {!chainActive && (() => {
          const bar = pushBarOf(pushStripOf(workbench?.episodes ?? [], barBatch, barPreview), workbench?.episodes ?? []);
          if (!bar.visible) return null;
          const click = () => { if (bar.legacy) void handoff.click(); else if (bar.episodes.length > 0) void barBatchActions.start(workbench?.episodes ?? [], bar.episodes); };
          return (
            <div className="wb-pushbar" data-tour="push-bar" role="region" aria-label="Đẩy sang Chapters">
              <span className="wb-pushbar-t">{bar.text}</span>
              <Tooltip title={bar.button.reason ?? undefined}>
                <span><Button type="primary" cta={pushCta && !arStrip} loading={barBatchActions.starting || handoff.checking} disabled={bar.button.disabled || disabled} onClick={click}>{bar.button.label}</Button></span>
              </Tooltip>
              {bar.hint && <span className="wb-pushbar-h">({bar.hint})</span>}
            </div>
          );
        })()}
        <ScriptFooter
          readerText={readerFooter(readerView, workbench?.seasonReader)} canViewReader={!!readerView} onOpenReader={() => setReaderOpen(true)}
        />
      </WbSlot>

      {listNeeds.length > 0 && (
        <div className="wb-needs" role="region" aria-label="Cần bạn xem">
          <div className="wb-needs-h">Cần bạn xem · {listNeeds.length}</div>
          {listNeeds.map((n, i) => (
            <div className="wb-need" key={`stage-${i}`}>
              <span className="wb-need-t"><Bang tone={n.blocker ? 'bad' : 'warn'} />{humanizeCodes(n.text)}</span>
              <Button size="small" onClick={n.go}>Đi tới</Button>
            </div>
          ))}
        </div>
      )}

      <div className="wb-sc-reader">
        {origin.fromReview && selectedEp !== null && (
          <div className="wb-rb-back">
            <Button type="link" size="small" onClick={backToReview}>← Về Sổ duyệt</Button>
            <Text type="secondary">Bạn đang xem tập {selectedEp} từ Sổ duyệt.</Text>
          </div>
        )}
        {selectedEp !== null ? (
          <EpisodeReader
            key={selectedEp}
            storyId={storyId} onEditDirty={onEditDirty} onManualSaved={() => { refreshAll(); notifyScriptSaved(); }}
            ep={selectedEp} row={rows.find((r) => r.ep === selectedEp)} wbEp={wbEp} script={script} outline={outline}
            reasons={wbEp ? episodeReviewReasons(wbEp, script, readerIssues) : []}
            readerNotes={readerNotesFor(readerView, selectedEp)}
            originalNameNotice={originalNameNotice}
            locked={locked} busy={disabled && !locked} writeBlockedBy={writeOneBlocker(selectedEp, scripts, splitMode)}
            onWriteOne={writeOne} onRewriteRange={rewriteRange} onAskAssistant={onAskAssistant}
            onOpenReader={() => { if (readerView) setReaderOpen(true); }}
            stageNeeds={episodeNeeds} visualExtras={visualExtras} openDropped={origin.openDropped}
            rowView={rowViewOf(selectedEp)}
            push={{ pushable: !!wbEp && isPushable(wbEp), pushed: wbEp?.handoff === 'up_to_date', busy: disabled || barBatchActions.starting, reason: null }}
            onPushOne={pushOneEp}
            autoRepairOne={autoRepairOneOf(workbench?.autoRepair, selectedEp) ? { label: AUTO_REPAIR_ONE_LABEL, loading: autoRepairApi.starting, disabled: disabled || autoRepairApi.starting, onClick: () => { void autoRepairApi.start([selectedEp]); } } : undefined}
            techBulkBar={scripts.length > 0 ? <VisualExtrasBulkBar api={visualExtras} locked={locked} shellBusy={disabled && !locked} /> : null}
          />
        ) : rows.length === 0 ? <Empty description="Chưa có tập nào để đọc" image={Empty.PRESENTED_IMAGE_SIMPLE} /> : (settled ? <div className="wb-reader-hint" data-testid="pick-hint">Chọn một tập ở cột bên trái.</div> : null)}
      </div>
      <HandoffBatchResults batch={barBatch} open={barBatchActions.resultsOpen} onClose={barBatchActions.closeResults} onCancel={(id) => { void barBatchActions.cancel(id); }} />

      {rewriteEp !== null && (
        <ConsequenceModal
          open onClose={() => setRewriteEp(null)} danger
          title={rewriteCopy(rewriteEp, versionOf(rewriteEp)).title} lead={rewriteCopy(rewriteEp, versionOf(rewriteEp)).lead} okText={rewriteCopy(rewriteEp, versionOf(rewriteEp)).okText}
          load={() => adaptationApi.rewriteImpact(storyId, rewriteEp)}
          fallback={<p>{rewriteCopy(rewriteEp, versionOf(rewriteEp)).fallback}</p>}
          errorFallback="Không viết lại được"
          onConfirm={async (view) => {
            // Gửi lại VÂN TAY của hộp vừa xem; lệch ⇒ `writeScripts` trả cờ, BE chưa mở job ⇒ hộp báo câu không mã + tải lại hệ quả. Không có (hộp cũ) ⇒ như trước.
            const fp = view?.base.fingerprint;
            const r = await scriptJob.writeScripts({ from: rewriteEp, to: rewriteEp, force: true, ...(typeof fp === 'string' && fp ? { expectedFingerprint: fp } : {}) }, `Viết lại tập ${rewriteEp}`);
            if (r === 'IMPACT_CHANGED') throw REWRITE_STALE();
          }}
        />
      )}
      <Drawer open={readerOpen} onClose={() => setReaderOpen(false)} width={640} title="AI đọc cả mùa">
        <div id="section-season-reader">
          <SeasonReaderCard
            storyId={storyId} onWriteScripts={async (o) => { await scriptJob.writeScripts(o); }} disabled={disabled} adoptJobId={pickJobId(workbench?.jobs.running, 'season_reader')}
            resp={seasonReader.resp} reload={seasonReader.reload}
            onChanged={() => { refreshAll(); }}
            onAskOptions={(req) => { setReaderOpen(false); onAskAssistant(req); }}
            optionsDisabledFor={(n) => seasonIssueDisabledReason({ stageLocked: locked, script: scriptByEp.get(n), editing: scriptEditing === n })}
          />
        </div>
      </Drawer>

      <HandoffModal plan={handoff.modalPlan} onClose={handoff.closeModal} />
    </StageFrame>
  );
};

export default ScriptStage;
